export class PostDocumentResponse {
  public packageId: string;
  public creationTimestamp: string;
}
